import { gql } from "@urql/core";

import { query } from "@/services/lukita";
import { statementsMetadataFragment, transactionFragment } from "../fragments";

export default function transactionsQuery({
  slug,
  accountId,
  first,
  skip,
  sort,
  from,
  channel,
}) {
  return query(
    gql`
      query TransactionsQuery($slug: String!, $accountId: ID!, $first: Int, $skip: Int, $sort: [StatementTransactionSort!], $from: StatementKind, $channel: StatementTransactionPaymentChannels) {
        project(slug: $slug, accountId: $accountId) {
          __typename
          slug
          items: transactions(first: $first, skip: $skip, sort: $sort, from: $from, channel: $channel) {
            ...statementTransaction
          }
          metadata: transactionsMetadata(from: $from, channel: $channel){
            count
          }
          statementsMetadata(from: $from) {
            ...statementsMetadata
          }
        }
        ${transactionFragment}
        ${statementsMetadataFragment}
      }
    `,
    {
      slug,
      accountId,
      channel,
      first,
      skip,
      sort,
      from,
    },
    { additionalTypenames: ["StatementRecord"] },
  );
}
